import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";

export default function Notes({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("Global notes")}</legend>
      <input
        name="addNote"
        onChange={onChange}
        value={searchObject.addNote || ""}
        className="form-control fontsize-legend"
        type="text"
      />
    </div>
  );
}
